var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessBulk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 142,
    viewBox: "0 0 400 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117 110L249 110V15L117 15V110Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M244.5 136C265.211 136 282 133.314 282 130C282 126.686 265.211 124 244.5 124C223.789 124 207 126.686 207 130C207 133.314 223.789 136 244.5 136Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M248 15H231V29H248V15Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260 7H231V25H260V7Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.5 25C126.881 25 128 24.1046 128 23C128 21.8954 126.881 21 125.5 21C124.119 21 123 21.8954 123 23C123 24.1046 124.119 25 125.5 25Z",
    fill: "#24285B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.5 25C133.881 25 135 24.1046 135 23C135 21.8954 133.881 21 132.5 21C131.119 21 130 21.8954 130 23C130 24.1046 131.119 25 132.5 25Z",
    fill: "#0D9F3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139 25C140.105 25 141 24.1046 141 23C141 21.8954 140.105 21 139 21C137.895 21 137 21.8954 137 23C137 24.1046 137.895 25 139 25Z",
    fill: "#FFD200"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M224.882 123.567C224.882 123.567 219.228 122.124 218 117.14C218 117.14 226.741 115.425 227 124L224.882 123.567Z",
    fill: "#0D9F3F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M225.968 123C225.968 123 221.925 116.813 225.429 111C225.429 111 232.222 115.17 229.246 123H225.968Z",
    fill: "#0D9F3F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M227 123C227 123 228.941 116.297 234.888 115C234.888 115 236.023 119.342 231.067 123H227Z",
    fill: "#0D9F3F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M222 123L223.254 131H230.904L232 123H222Z",
    fill: "#24285B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M154.496 91C148.487 90.999 142.658 88.9563 137.963 85.207C133.268 81.4577 129.987 76.2243 128.657 70.365C127.327 64.5058 128.028 58.3687 130.645 52.96C133.261 47.5514 137.638 43.1925 143.057 40.598C148.476 38.0036 154.616 37.3277 160.47 38.6812C166.324 40.0347 171.544 43.3373 175.274 48.0472C179.004 52.7572 181.023 58.595 181 64.6031C180.976 70.6113 178.912 76.4332 175.145 81.114L167.561 74.9982C169.97 72.0288 171.277 68.3178 171.261 64.4946C171.261 61.1808 170.279 57.9414 168.438 55.1861C166.597 52.4308 163.98 50.2833 160.918 49.0152C157.857 47.7471 154.488 47.4153 151.238 48.0617C147.988 48.7082 145.002 50.304 142.659 52.6472C140.316 54.9904 138.72 57.9758 138.074 61.2259C137.427 64.476 137.759 67.8448 139.027 70.9064C140.295 73.9679 142.443 76.5847 145.198 78.4257C147.953 80.2667 151.193 81.2494 154.506 81.2494L154.496 91Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M181 65H171.435C171.424 60.4766 169.689 56.1419 166.609 52.9439C163.529 49.7458 159.355 47.9448 155 47.9346V38C161.892 38.0102 168.498 40.858 173.372 45.9191C178.246 50.9802 180.989 57.8418 181 65Z",
    fill: "#0D9F3F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M155 90.9999V81.4352C157.191 81.4431 159.361 81.0091 161.381 80.1591C163.4 79.3091 165.228 78.0606 166.754 76.4882C166.85 76.3925 166.94 76.2969 167.03 76.1959C169.868 73.1595 171.443 69.1562 171.435 65H181C181.009 71.5761 178.517 77.9095 174.028 82.7158C173.885 82.8752 173.736 83.0293 173.593 83.1781C171.177 85.6634 168.286 87.6368 165.092 88.9806C161.898 90.3244 158.465 91.0112 155 90.9999Z",
    fill: "#24285B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M155 90.9999V81.3052C157.187 81.3132 159.354 80.8733 161.37 80.0117C163.386 79.1501 165.21 77.8846 166.733 76.2908L167.009 76L174 82.6032L173.56 83.0717C171.149 85.5908 168.263 87.591 165.074 88.9531C161.886 90.3152 158.459 91.0113 155 90.9999Z",
    fill: "#FFD200"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M195 40H189V44H195V40Z",
    fill: "#A5A5A5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M195 47H189V51H195V47Z",
    fill: "#A5A5A5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M195 54H189V58H195V54Z",
    fill: "#A5A5A5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M216 40H199V44H216V40Z",
    fill: "#A5A5A5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M216 47H199V51H216V47Z",
    fill: "#A5A5A5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M216 54H199V58H216V54Z",
    fill: "#A5A5A5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M163 97H147V102H163V97Z",
    fill: "#A5A5A5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M154.769 70.9992H154.721C154.449 70.9914 154.183 70.92 153.949 70.7916C153.715 70.6632 153.52 70.482 153.383 70.2652L150.251 65.2702C150.134 65.102 150.056 64.9139 150.021 64.7173C149.986 64.5206 149.995 64.3194 150.046 64.1258C150.098 63.9322 150.191 63.7502 150.321 63.5908C150.451 63.4313 150.615 63.2977 150.802 63.198C150.99 63.0982 151.197 63.0344 151.412 63.0104C151.627 62.9863 151.846 63.0026 152.054 63.0581C152.262 63.1136 152.455 63.2073 152.623 63.3335C152.791 63.4597 152.929 63.6158 153.029 63.7924L154.892 66.748L160.053 59.6594C160.171 59.4977 160.321 59.3588 160.496 59.2506C160.672 59.1424 160.869 59.0671 161.076 59.0289C161.283 58.9907 161.496 58.9904 161.703 59.028C161.91 59.0656 162.108 59.1404 162.283 59.2481C162.459 59.3558 162.61 59.4943 162.728 59.6557C162.845 59.8171 162.927 59.9983 162.969 60.1888C163.01 60.3793 163.01 60.5755 162.97 60.7661C162.929 60.9567 162.847 61.1381 162.73 61.2998L156.145 70.3588C155.993 70.5632 155.787 70.729 155.546 70.8409C155.306 70.9528 155.039 71.0072 154.769 70.9992Z",
    fill: "#A5A5A5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M241 16H238V21H241V16Z",
    fill: "#A5A5A5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M248 13H244V21H248V13Z",
    fill: "#A5A5A5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M254 18H251V21H254V18Z",
    fill: "#A5A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBulk);
export default __webpack_public_path__ + "static/media/successBulk.75e3b19b9912ae6d3aa3caffffa3bff6.svg";
export { ForwardRef as ReactComponent };